import React, { useState, lazy } from 'react';
import { Menu, X, Facebook, Instagram } from 'lucide-react';
import { Button } from './ui/Button';
interface HeaderProps {
  onJoinClick?: () => void;
}
export function Header({
  onJoinClick
}: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    label: 'HOME',
    href: '/'
  }, {
    label: 'STORAGE FACILITY',
    href: '/#features'
  }, {
    label: 'SECURITY & TERMS',
    href: '/#security'
  }, {
    label: 'REGISTER INTEREST',
    href: '/#pricing'
  }, {
    label: 'CONTACT US',
    href: '/#contact'
  }];
  return <header className="bg-[#fbf7dd] shadow-sm sticky top-0 z-50 overflow-visible" data-id="element-332">
      {/* Social Bar */}
      <div className="absolute top-0 left-0 p-2 hidden lg:flex gap-2" data-id="element-333">
        <a href="#" className="text-gray-400 hover:text-[#175445] transition-colors" data-id="element-334">
          <Facebook className="h-4 w-4" data-id="element-335" />
        </a>
        <a href="#" className="text-gray-400 hover:text-[#175445] transition-colors" data-id="element-336">
          <Instagram className="h-4 w-4" data-id="element-337" />
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-338">
        <div className="flex justify-between items-center h-20" data-id="element-339">
          {/* Logo - oversized, hangs below the navbar */}
          <a href="/" className="flex-shrink-0 cursor-pointer group relative z-[60]" data-id="element-340">
            <img src="https://cdn.magicpatterns.com/uploads/8iyBWSo8vRExHMrz3iz275/Hold_My_Van_Full_Colour_Logo_1500px_V1.png" alt="Hold My Van" className="h-28 w-28 rounded-full ring-4 ring-[#fbf7dd] shadow-lg group-hover:opacity-90 transition-opacity bg-[#fbf7dd]" loading="eager" fetchPriority="high" width="112" height="112" data-id="element-341" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-342">
            {navItems.map(item => <a key={item.label} href={item.href} className="text-base font-bold text-gray-700 hover:text-[#175445] transition-colors uppercase tracking-wide" data-id="element-343">
                {item.label}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-344">
            <Button variant="secondary" size="sm" onClick={onJoinClick} data-id="element-345">
              Join the priority list
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden" data-id="element-346">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-[#175445] p-2" data-id="element-347">
              {isMenuOpen ? <X className="h-8 w-8" data-id="element-348" /> : <Menu className="h-8 w-8" data-id="element-349" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-[#fbf7dd] border-t border-gray-100 absolute w-full shadow-lg z-[55]" data-id="element-350">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-351">
            {navItems.map(item => <a key={item.label} href={item.href} className="block px-3 py-2 text-lg font-bold text-gray-700 hover:text-[#175445] hover:bg-gray-50 uppercase" onClick={() => setIsMenuOpen(false)} data-id="element-352">
                {item.label}
              </a>)}
            <div className="mt-4 px-3" data-id="element-353">
              <Button variant="secondary" className="w-full" onClick={onJoinClick} data-id="element-354">
                Join the priority list
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}